import { useState } from "react";
import { useTheme } from "@/context/ThemeContext";
import { BACKEND_URL } from "@/lib/api";

function Mark({ dim }) {
  return (
    <svg viewBox="0 0 48 48" className={dim} aria-hidden="true">
      <path d="M24 4l2.2 5.2L31 11l-4.8 1.8L24 18l-2.2-5.2L17 11l4.8-1.8z" fill="var(--brand-accent)" />
      <path d="M6 18c7 0 13 2 18 7v17c-5-5-11-7-18-7z" fill="var(--brand)" />
      <path d="M42 18c-7 0-13 2-18 7v17c5-5 11-7 18-7z" fill="var(--brand-dark)" />
      <circle cx="24" cy="21" r="3" fill="var(--brand-accent)" />
    </svg>
  );
}

export function Logo({ size = "md", onDark = false, stacked = false }) {
  const { theme } = useTheme();
  const [imgOk, setImgOk] = useState(true);
  const dim = size === "sm" ? "h-8 w-8" : size === "lg" ? "h-14 w-14" : "h-10 w-10";
  const text = size === "sm" ? "text-lg" : size === "lg" ? "text-3xl" : "text-xl";
  const [first, ...rest] = (theme.school_name || "SPARKORA EDU").split(" ");
  const showImg = theme.logo_url && imgOk;
  return (
    <div data-testid="app-logo" className={`flex ${stacked ? "flex-col items-center gap-1" : "items-center gap-2.5"}`}>
      {showImg
        ? <img src={`${BACKEND_URL}/api/settings/logo?v=${encodeURIComponent(theme.logo_url)}`} alt={theme.school_name} onError={() => setImgOk(false)} className={`${dim} object-contain`} />
        : <Mark dim={dim} />}
      <div className={`leading-none ${stacked ? "text-center" : ""}`}>
        <div className={`font-display font-extrabold tracking-tight ${text} ${onDark ? "text-white" : "text-[color:var(--brand-dark)]"}`}>
          {first} {rest.length > 0 && <span className="px-1.5 rounded-md italic" style={{ background: "var(--brand-accent)", color: "#fff" }}>{rest.join(" ")}</span>}
        </div>
        {!stacked && (
          <div className={`text-[9px] uppercase tracking-[0.2em] mt-1 ${onDark ? "text-white/70" : "text-slate-500"}`}>{theme.tagline}</div>
        )}
      </div>
    </div>
  );
}
